import Site from "../../model/site/Site";
import {Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import Address from "../../model/address/Address";

export function getSite(siteId: string, state: RootState): Option<Site> {
	const site = state.site.sitesMap[siteId];
	return option(site);
}

export function getAddress(siteId: string, state: RootState): Option<Address> {
	return getSite(siteId, state).map(site => site.data.address);
}

export function isSiteLoading(state: RootState):boolean {
	return !state.site.allSitesFetched;
}